import { createContext, useContext, useEffect, useState } from 'react'

const PageTitleContext = createContext(undefined)

export const PageTitleProvider = ({ children }) => {
    const [title, setTitle] = useState('Strive2Help')

    useEffect(() => {
        document.title = title
    }, [title])

    return <PageTitleContext.Provider value={{ setTitle }}>{children}</PageTitleContext.Provider>
}

export const usePageTitle = () => {
    const context = useContext(PageTitleContext)
    if (!context) throw new Error('usePageTitle must be used within a PageTitleProvider')
    return context
}
